export default __webpack_public_path__ + "static/media/logo-tm.6ede784a.svg";